import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  margin-top: 10px;
  margin: 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 15px;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};

  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 479px) {
    width: 100%;
    margin: 5px;
    padding: 15px 5px;
    flex-wrap: wrap;
    gap: 1rem;
  }

  @media screen and (min-width: 480px) and (max-width: 885px) {
    width: 100%;
    margin: 5px;
    padding: 15px 5px;
    flex-wrap: wrap;
    gap: 1rem;
  }
`;

export const ListStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LabelSearch = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  font-family: "poppins";
  font-size: 0.8rem;
  margin: 0 15px 0 15px;
  white-space: nowrap;
`;

export const GoButton = styled.button`
  display: flex;
  justify-content: space-between;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border-radius: 10px;
  align-items: center;
  padding: 5px 40px;
  margin-left: 15px;
  white-space: nowrap;

  @media screen and (max-width: 479px) {
    margin-left: unset;
  }
`;

export const ActionBar = styled.div`
  display: flex;
  font-weight: 500;
  font-family: "poppins";
  font-size: 0.8rem;
  color: ${theme.colors.black};
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 15px 10px 15px;
  cursor: text;
`;

export const CloseButton = styled.button`
  display: flex;
  background-color: ${theme.colors.white};
  cursor: pointer;
`;

export const BoxComponentStyled = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const BoxFilterContainer = styled.div`
  display: flex;
  position: relative;
  max-width: 300px;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.lightGray};
  width: 43px;
  height: 43px;
  border-radius: 50%;
  cursor: pointer;
`;

export const BoxSearchContainer = styled.div`
  margin-right: 15px;
  display: flex;
  position: relative;
  min-width: 300px;
  align-items: center;

  svg {
    position: absolute;
    right: 15px;
    top: 10px;
  }

  @media screen and (max-width: 479px) {
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    min-width: unset;
    margin-right: unset;
  }
`;

export const InputSearch = styled.input`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${theme.colors.lightGray};
  border-radius: 100px;
  padding: 7px 25px;
  min-width: 250px;
  width: 100%;
  background-color: transparent;
  border-radius: 10px !important;

  font-weight: 300;
  font-family: "poppins";
  font-size: 0.8rem;
  color: ${theme.colors.white};

  @media screen and (max-width: 479px) {
    min-width: unset;
  }
`;

type ItemProp = {
  selected: boolean;
};

export const ItemStyled = styled.span`
  font-family: "poppins";
  font-weight: 400;
  font-size: 0.6rem;
  color: ${theme.colors.primary};
  padding: 15px 15px 10px 15px;
  cursor: pointer;
  width: 0;
  border-bottom: ${(p: ItemProp) =>
    p.selected ? `3px solid ${theme.colors.primary}` : "2px solid #EFEFEF"};
`;

type DropDownProps = {
  open: boolean;
};

export const DropDownStyled = styled.div`
  display: flex;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 7px 50px rgb(210 214 227 / 40%);
  padding: 0px 0px;
  position: absolute;
  background-color: #fff;
  max-width: 312px;
  width: auto;
  top: calc(100% + 15px);
  right: 0;
  flex-direction: column;
  opacity: ${(p: DropDownProps) => (p.open ? 1 : 0)};
  visibility: ${(p: DropDownProps) => (p.open ? "visible" : "hidden")};
  transition: ease all 400ms;
  border: 0.5px solid #efefef;
  z-index: 9;

  &:before {
    content: "";
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 17px solid #ffffff;
    width: 0;
    height: 0;
    position: absolute;
    top: -17px;
    right: 25px;
    /* border-radius: 26px; */
    box-shadow: 0px 7px 50px 0px rgb(210 214 227 / 40%);
  }
`;
